import type { MarketplaceSearch } from "domains/schedule/utils/useMarketplaceSearch";

export function getDirectOfferIds(params: MarketplaceSearch) {
  const commaIndex = params.offer_group?.indexOf(",") ?? -1;
  const firstGroupId = commaIndex === -1 ? params.offer_group : params.offer_group?.slice(0, commaIndex);
  return {
    hasDirectOffer: !!params.offer_pro || !!params.offer_group,
    proId: params.offer_pro,
    proIds: params.offer_pro ? [params.offer_pro] : undefined,
    groupId: params.offer_group ? Number(firstGroupId) : undefined,
    groupIds: params.offer_group ? params.offer_group.split(",").map(Number) : undefined,
    returnTo: params.return_to,
    candidateId: params.offer_candidate_id,
    jobPostingId: params.offer_job_posting_id,
  };
}
